import { IDestroyOptions } from "pixi.js";
import { Scales } from "../../../canvas/CanvasScaler";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { FadeScreen } from "./FadeScreen";

export class FullScreenFade extends FadeScreen {
    public constructor(
        private readonly canvasScaler: ICanvasScaler,
        alpha: number,
        inputBlock: boolean = true
    ) {
        super(canvasScaler.browserWidth, canvasScaler.browserHeight, alpha, inputBlock);
        this.canvasScaler.onResize.add(this.layout, this);
        this.layout(this.canvasScaler.getSize());
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.canvasScaler.onResize.remove(this.layout, this);
        super.destroy(options);
    }

    private layout(scales: Scales): void {
        const scale = scales.height / this.canvasScaler.browserHeight;
        this.width = this.canvasScaler.browserWidth * scale;
        this.height = this.canvasScaler.browserHeight * scale;
        this.position.x = (this.canvasScaler.referenceWidth - this.width) * 0.5;
    }
}
